import ModeIcon from '@mui/icons-material/Mode';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import './NotificationFrequency.scss';
import { useTranslation } from 'react-i18next';
import NotificationFrequencyOptions, {
  DEFAULT_FREQUENCY,
  FREQUENCY_OPTIONS,
} from './NotificationFrequencyOptions';

export const NotificationFrequency = ({ fieldName = 'frequency' }: { fieldName?: string }) => {
  const [openSelect, setOpenSelect] = useState(false);
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const frequency: string[] = watch(fieldName, DEFAULT_FREQUENCY);

  const handleIconClick = () => {
    setOpenSelect(!openSelect);
  };

  const frequenciesText = frequency
    .sort((a, b) => FREQUENCY_OPTIONS.indexOf(a) - FREQUENCY_OPTIONS.indexOf(b))
    .map((item: string) => {
      if (frequency.length >= 2) {
        return t(`components:notifications_manager.frequency_options.${item}`).slice(0, 3);
      }
      return t(`components:notifications_manager.frequency_options.${item}`);
    })
    .join(', ');
  return (
    <div className="notification-frequency-wrapper">
      <p className="notification-frequency" onClick={handleIconClick}>
        {frequenciesText}
      </p>

      <ModeIcon className="mode-icon" onClick={handleIconClick} />
      {openSelect && (
        <NotificationFrequencyOptions
          fieldName={fieldName}
          onClickAway={() => setOpenSelect(false)}
        />
      )}
    </div>
  );
};
